module.exports = __webpack_public_path__ + "img/clock.c021c64b.webp";